import type { ListParams } from '../type';
import baseKey from './_baseKey';

const managerDomainKey = () => baseKey.domainKey('manager');

/**
 * 매니저 관련 쿼리키 제너레이터
 */
const managerKey = {
  /**
   * @returns 매니저 도메인 기본 쿼리키 (getter)
   * @example ['manager']
   */
  domain() {
    return managerDomainKey();
  },
  /**
   * @param listParams 리스트 파라미터
   * @returns 무한 스크롤 방식 크루 리스트 데이터 요청 쿼리키
   * @example ['manager', 'list', 'scroll', {...listParams}]
   */
  listByScroll(listParams?: ListParams) {
    const coreKey = baseKey.listKey(managerDomainKey(), 'scroll');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
  /**
   * @param listParams 리스트 파라미터
   * @returns 페이지네이션 방식 매니저 리스트 데이터 요청 쿼리키
   * @example ['manager', 'list', 'page', {...listParams}]
   */
  listByPage(listParams?: ListParams) {
    const coreKey = baseKey.listKey(managerDomainKey(), 'page');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
  /**
   * @param listParams 리스트 파라미터
   * @returns 매니저 리스트 데이터 요청 쿼리키
   * @example ['manager', 'list', {...listParams}]
   */
  responsible(listParams?: ListParams) {
    const coreKey = baseKey.listKey(managerDomainKey(), 'all');
    return listParams ? [...coreKey, listParams] : coreKey;
  },

  /**
   * @param data 매니저 변경 데이터
   * @returns 매니저 변경 요청 쿼리키
   * @example ['responsible-manager', 'change', {...data}]
   */
  changeResponsible(operatorTeamMemberIds: number[], managerId: number) {
    return [
      ...managerDomainKey(),
      'change',
      { operatorTeamMemberIds, managerId },
    ];
  },
};

export default Object.freeze(managerKey);
